import { Injectable, Inject } from '@angular/core';
import {
  Http,
  Response,
  URLSearchParams,
  Headers,
  RequestOptionsArgs,
  RequestOptions
} from '@angular/http';
import { apiUrl, apiUrlcommon } from './../app.config';
import { IAppConfig } from '../iapp.config';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs/Rx';
import { OsusumeCategory, OsusumeCategoryList } from '../models/plan/osusume';
import { DataService } from './data.service';

@Injectable()
export class OsusumeService {
  public defaultHeaders: Headers = new Headers();
  public listCategory: OsusumeCategory[];
  public kyotenCd: string;
  public loadCategory = new Subject();
  public reLoadOsusume = new Subject();
  constructor(private http: Http, private router: Router, private _data: DataService) {}

  setCategoryArray(listCategory: OsusumeCategoryList) {
    let list = [];
    if (listCategory.categoryTitle1) {
      list.push(listCategory.categoryTitle1);
    }
    if (listCategory.categoryTitle2) {
      list.push(listCategory.categoryTitle2);
    }
    if (listCategory.categoryTitle3) {
      list.push(listCategory.categoryTitle3);
    }
    return list;
  }

  getCategory(kyotenCd: string) {
    const path = `${apiUrl}` + `/planTemplates/userCategories/${kyotenCd}`;
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
    };
    this.kyotenCd = kyotenCd;
    return this.http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return null;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError);
  }
  updateCategory(kyotenCd: string, categoryNo: number, category: OsusumeCategory): Observable<any> {
    const path = `${apiUrl}` + `/planTemplates/userCategories/${kyotenCd}/${categoryNo}`;
    // const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const value = JSON.stringify(category);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams,
      body: value
      // search: queryParameters
    };
    return this.http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 200) {
          return true;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return false;
        }
      })
      .catch(this.handleError2);
  }

  getplanTemplates(kyotenCd: string, categoryNo: number, isManage?: boolean) {
    let path;
    let pathManage = '';
    if (isManage) {
      pathManage = '/manageList';
    }
    if (kyotenCd && categoryNo) {
      path = `${apiUrl}/planTemplates${pathManage}/${kyotenCd}/${categoryNo}`;
    } else {
      path = `${apiUrl}/planTemplatesHq${pathManage}`;
    }

    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams
    };
    return this.http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return null;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError);
  }

  removePlan(id: string, isHq: boolean): Observable<any> {
    let path = 'planTemplates';
    if (isHq) {
      path = 'planTemplatesHq';
    }
    const url = `${apiUrl}/${path}/${id}`;
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'DELETE',
      headers: headerParams
    };
    return this.http
      .request(url, requestOptions)
      .map((response: Response) => {
        if (response.status === 200) {
          return true;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return false;
        }
      })
      .catch(this.handleError2);
  }

  createOsusumePlan(mitsumoriCd: string, kyotenCd?: string, categoryNo?: number): Observable<any> {
    let url;
    if (kyotenCd && categoryNo) {
      url = `${apiUrl}/planTemplates/${kyotenCd}/${categoryNo}`;
    } else {
      url = `${apiUrl}/planTemplatesHq`;
    }
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const postValue = JSON.stringify({'mitsumoriCd': mitsumoriCd});
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'POST',
      headers: headerParams,
      body: postValue
    };
    return this.http
      .request(url, requestOptions)
      .map((response: Response) => {
        if (response.status === 200) {
          return true;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return false;
        }
      })
      .catch(this.handleError.bind(this));
  }

  changePlanOrder(listorder: number[], kyotenCd?: string, categoryNo?: number): Observable<any> {
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    let url;
    if (kyotenCd && categoryNo) {
      url = `${apiUrl}/planTemplates/${kyotenCd}/${categoryNo}/displayOrder`;
    } else {
      url = `${apiUrl}/planTemplatesHq/displayOrder`;
    }
    const postValue = JSON.stringify(listorder);
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams,
      body: postValue
    };
    return this.http
      .request(url, requestOptions)
      .map((response: Response) => {
        if (response.status === 200) {
          return true;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return false;
        }
      })
      .catch(this.handleError2);
  }

  setEnable(id: number, enabled: number, isHq: boolean): Observable<any> {
    let path = 'planTemplates';
    if (isHq) {
      path = 'planTemplatesHq';
    }
    const url = `${apiUrl}/${path}/${id}/enabled/${enabled}`;
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams
    };
    return this.http
      .request(url, requestOptions)
      .map((response: Response) => {
        if (response.status === 200) {
          return true;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return false;
        }
      })
      .catch(this.handleError2);
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  deleteToken() {
    const token = this._data.token;
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this.http
        .delete(`${apiUrl}/auth/token`, { headers: headerParams })
        .subscribe(() => {});
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }

  private handleError2(error: any) {
    // console.log('error', error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/osusume.service.ts